<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <input id="fileInput" type="file" style="display:none" v-on:change="chooseFile()" accept="application/json"/>
            <b-col>
                <h1>{{ecmResourceStrings.ttlECMReposImport}}</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <otif-button class=" OTSecondary" @click.native="open" id="OTECMChooseFile" :title="ecmResourceStrings.tipECMReposChooseFile" >{{ecmResourceStrings.lblChooseFile}}</otif-button>
                <otif-button class=" OTPrimary" @click.native="saveInRepository" id="OTSaveSetting" :title="ecmResourceStrings.tipECMSaveECMRepositories" :disabled="filetext === '' || importstarted == true" >{{ecmResourceStrings.lblSave}}</otif-button>
            </b-col>
        </b-row>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblFileName"
            v-bind:readonly=true
            :disabled=true
            :description="ecmResourceStrings.txtECMReposChooseFile"
            v-model="form.filename"/>
         <b-row>
            <b-col>
                <ImportTable
                :rows="repoList"
                :columns="columns"
                :validations="tableValidations"
                :customOptions="customOptions"
                :validationOptions="idlist"
                :formcolumn="formColumns"
                @check="check" 
                @save="save"
                >
            </ImportTable>
            </b-col>
        </b-row>
        
       
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import ProvideCredo from '../../modals/ECMCrawlerPassword.vue';
import { showMessage} from '../../../utils/commonECM.js';
import ImportTable from '@/ecm/components/ECMImportTable.vue';
import CheckColumn from '../../links/ecmcheckboxes.vue';
import ImportStatusColumn from '../../links/ecmimportstatus.vue';
import ecmRepositories from '@/ecm/collections/ecmrepositories.js';
import ecmRepositoryTypes from '@/ecm/collections/ecmrepositorytypes.js';
import { required } from 'vuelidate/lib/validators';
import { repoid } from '../../../utils/validatorECM.js';
import { duplication } from '../../../utils/validatorECM.js';
import ErrorColumn from '../../links/ecmimporterror.vue';

export default {
    components: {
         ECMErrorDialog,
         ImportTable,
     },

    data() {
        return {
          
            HTMLcontent: null,
            messageDlg:false,
            loaded: false,
            importstarted:false,
            filetext:'',
            originRepoList : [], 
            idlist:[],
            namelist:[],
            typelist:[],
            repoList : [], 
            compcheck:null,
            //collect all import results
            errorearray:[],
            originalselectednum:0,
            processednum:0,
            ecmRepositoryTypes: new ecmRepositoryTypes({paginated: false }),
            ecmRepositories: new ecmRepositories({paginated: false }),
            ecmResourceStrings: require('../../../utils/resourceECM.js'),
            form:{
                filename:'',
            },
            customOptions:  [],
            formColumns:['2','5'],
            
            columns: [
            {
                name: 'checked',
                label: '',
                sortable: false,
                editable:false,
                checkable:true,
                checked:true,
                checkStat:this.getCheckStatus(),
                displayComponent:CheckColumn,
                width:'3%',
            }, {
                name: 'status',
                label: '',
                sortable: false,
                editable:false,
                checkable:false,
                width:'3%',
                displayComponent:ImportStatusColumn,
            },{
                name: 'repositoryId',
                label: 'ID',
                sortable: true,
                editable:true,
                checkable:false,
                width:'9%',
                invalidMessage: "ID is required and should be a unique numeric value.",
                render(row) {
                    return row.repositoryId;
                }
            },{
                name: 'repositoryName',
                label: 'Name',
                sortable: true,
                editable:false,
                checkable:false,
                width:'18%',
                render(row) {
                    return row.repositoryName;
                }
            },{
                name: 'repositoryType',
                label: 'Type',
                sortable: false,
                editable:false,
                checkable:false,
                width:'18%',
                render(row) {
                    return row.repositoryType;
                }
            },{
                name: 'description',
                label: 'Description',
                sortable: false,
                editable:true,
                checkable:false,
                width:'18%',
                render(row) {
                    return row.description;
                }
            },{
                name: 'importstatus',
                label: 'Import Status',
                sortable: false,
                editable:false,
                checkable:false,
                width:'15%',
                displayComponent:ErrorColumn,
            }],
            tableValidations: {
                checked:{},
                status:{},
                repositoryId: {
                    required,
                    repoid,
                    duplication
                },
                repositoryName:{},
                repositoryType:{},
                description:{},
                importstatus:{},
            },
        }
    },

    computed: {
         repositories() {
            return [];
        }
    },

    methods: {

        getCheckStatus(){return 'unchecked';},

        check(colNumber, dir)
        {
            var that=this;

            if(that.repoList)
            {
                var i = 0;

                for(i=0;i<that.repoList.length;i++)
                {
                    var dataval = that.repoList[i];
                    
                    if(dataval)
                    {
                        if(dataval.checked != null)
                        {
                            if(dir == 'checked')
                            {
                                if(dataval.status == that.ecmResourceStrings.readytoimport || dataval.status == that.ecmResourceStrings.importerror)
                                {
                                    dataval.checked=true;
                                }
                            }
                            else
                            {
                                if(dataval.status == that.ecmResourceStrings.readytoimport || dataval.status == that.ecmResourceStrings.importerror)
                                {
                                    dataval.checked=false;
                                }
                            }
                        }
                    }
                }
            }
        },
    
        save(element, rowNumber)
        {
            var that = this;
            const valueid = element.repositoryId.trim();
            const valuename = element.repositoryType + " @ " + valueid.toString();
            var valuedescription = '';
            if(element.description)
                valuedescription =element.description.trim();
            
            if(that.repoList[rowNumber])
            {
                var onerepo = that.repoList[rowNumber];
                if(onerepo)
                {
                    onerepo.repositoryId = valueid;
                    onerepo.repositoryName = valuename;
                    onerepo.description = valuedescription;
                    onerepo.status = that.ecmResourceStrings.readytoimport;
                    onerepo.checked = true;
                }
            }
        },

        open(){
            const event = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': true
            });
            const element = document.getElementById('fileInput');
            if(element)
            {
                element.dispatchEvent(event);
            }
        },

        chooseFile()
        {
            var that = this;
            const element = document.getElementById('fileInput');
            if(element)
            {
                if(element.files.length == 0)
                {
                    //cancel was pressed, nothing changed
                    return;
                }
                if(that.form.filename !== "" && that.form.filename !== element.files[0].name )
                {
                    that.HTMLcontent=null;
                    that.importstarted=false;
                    that.filetext = '';
                    that.originRepoList=[];
                    that.repoList=[]; 
                    that.errorearray=[];
                    that.form.filename='';
                    that.originalselectednum=0;
                    that.processednum=0;
                }
                for (let file of element.files) {
                    that.filetext='';
                    that.form.filename =element.files[0].name;
                    that.readFile(element.files[0]);
                }
            }
        },

        readFile(filex) {
            var that = this;
            const start = 0;
            const stop = filex.size - 1;
            var reader = new FileReader();
            reader.onloadend = function(evt)
            {
                if (evt.target.readyState == FileReader.DONE)// DONE == 2
                {
                    that.filetext =  evt.target.result;
                    that.getText('json');
                }
            };
            const blob = filex.slice(start, stop + 1);
            reader.readAsText(blob, 'UTF-8');   // reader.readAsBinaryString(blob);
        },

        getText(type)
        {
            var that = this;
            if(that.filetext)
            {
                var jsonObject = undefined;
                try
                {
                    jsonObject = JSON.parse(that.filetext);
                    if(jsonObject)
                    {
                        var repositories = jsonObject.ecmRepository;
                
                        if(repositories == undefined)
                        {
                            var repoobject = jsonObject;
                        
                            if(repoobject)
                            {
                                if(repoobject.repositoryType != 'dbms_generic_v1')
                                {
                                    that.getHTMLTextFromJson(jsonObject);
                                }
                                else
                                {
                                    this.$snotify.info(this.ecmResourceStrings.txtNothingToRead); 
                                }
                            }
                        }
                        else
                        {
                            var i = 0;
                    
                            if(repositories != undefined)
                            {
                                for(i = repositories.length - 1; i > -1 ; i--)
                                {
                                    var repoobject = repositories[i];

                                    if(repoobject)
                                    {
                                        if(repoobject.repositoryType == 'dbms_generic_v1')
                                        {
                                            jsonObject.ecmRepository.splice(i, 1);
                                        }
                                    }
                                }
                                if(jsonObject.ecmRepository.length > 0)
                                {
                                    that.getHTMLTextFromJson(jsonObject);
                                }
                                else
                                {
                                    this.$snotify.info(this.ecmResourceStrings.txtNothingToRead); 
                                }
                            }
                        }
                    }
                }
                
                catch(e)
                {
                    const divHTML = 'No preview available';
                    /*const element = document.getElementById('textreposarea');
                    if(element)
                    {
                        element.innerHTML = divHTML;
                    }*/
                    this.filetext = '';
                    showMessage(this, 'error', this.ecmResourceStrings.txtError,this.ecmResourceStrings.txtECMReadFileError, true, e.toString());
                }
            }
        },

        getHTMLTextFromJson:function(jsonObject)
        {
            var that = this;
            var btoadd=false;
            //if collection already was initialized
            if(that.originRepoList.length == 0)
            {
                btoadd = true;
            }
                 
            if(jsonObject)
            {
                var repositories = jsonObject.ecmRepository;
                
                if(repositories == undefined)
                {
                    var repoobject = jsonObject;
                        
                if(repoobject)
                {
                    const test = repoobject.repositoryId;
                   
                    if(btoadd == true)
                    {
                        const getData = that.getItemStatus(repoobject);
                        const stat = getData.status;
                        const statusdescription = getData.statusdescription;
                        var checked=false;
                        if(stat == that.ecmResourceStrings.readytoimport)
                        {
                            checked=true;
                            that.compcheck=true;
                        }
                        else if(stat == that.ecmResourceStrings.importsuccess || stat == that.ecmResourceStrings.typedoesnotexist)
                        {
                            checked=null;
                        }
                        if(repoobject.description)
                        {
                            that.originRepoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                repositoryType: repoobject.repositoryType, description : repoobject.description, configData : repoobject.configData, status: stat, statusdescription :statusdescription,
                                importstatus:''});
                            that.repoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                repositoryType: repoobject.repositoryType, description : repoobject.description, configData : repoobject.configData, status: stat, statusdescription :statusdescription,
                                importstatus:'', checked:checked});
                            }
                            else
                            {
                                that.originRepoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                    repositoryType: repoobject.repositoryType, description : null, configData : repoobject.configData, status: stat, statusdescription: statusdescription, importstatus:''}); 
                                that.repoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                    repositoryType: repoobject.repositoryType, description : null, configData : repoobject.configData, status: stat, statusdescription: statusdescription, importstatus:'', checked:checked}); 
                            }
                        }
                    }
                }
                else
                {
                    var i = 0;
                    
                    if(repositories != undefined)
                    {
                        for(i = 0; i < repositories.length; i++)
                        {
                            var repoobject = repositories[i];

                            if(repoobject)
                            {
                                if(btoadd == true)
                                {
                                    const getData = that.getItemStatus(repoobject);
                                    const stat = getData.status;
                                    const statusdescription = getData.statusdescription;
                                    var checked=false;
                                    if(stat == that.ecmResourceStrings.readytoimport)
                                    {
                                        checked=true;
                                    }
                                    else if(stat == that.ecmResourceStrings.importsuccess || stat == that.ecmResourceStrings.typedoesnotexist)
                                    {
                                        checked=null;
                                    }
                                    if(repoobject.description)
                                    {
                                        that.originRepoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                            repositoryType: repoobject.repositoryType, description : repoobject.description, configData : repoobject.configData, status : stat, statusdescription:statusdescription, importstatus:'' });
                                        that.repoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                            repositoryType: repoobject.repositoryType, description : repoobject.description, configData : repoobject.configData, status : stat, statusdescription:statusdescription, importstatus:'', checked:checked }); 
                                    }
                                    else
                                    {
                                        that.originRepoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                            repositoryType: repoobject.repositoryType, description : null, configData : repoobject.configData, status: stat, statusdescription:statusdescription, importstatus:''}); 
                                        that.repoList.push({ repositoryId: repoobject.repositoryId, repositoryName: repoobject.repositoryName,
                                            repositoryType: repoobject.repositoryType, description : repoobject.description, configData : repoobject.configData, status : stat, statusdescription:statusdescription, importstatus:'', checked :checked }); 
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },

        getItemStatus: function(repoobject)
        {
            var that = this;
            var stat = that.ecmResourceStrings.readytoimport;
            var statusdescription = that.ecmResourceStrings.txtImportStatusReadyToImport;

            var id = 0;
            var name='';
            var type='';
            if(repoobject.repositoryId)
            {
                id=repoobject.repositoryId.toString();
                name=repoobject.repositoryName;
                type=repoobject.repositoryType;
            }
            else
            {
                if(repoobject.attributes && repoobject.attributes['repositoryId'])
                {
                    id = repoobject.attributes['repositoryId'].toString();
                    name=repoobject.attributes['repositoryName'].toString();
                    type=repoobject.attributes['repositoryType'].toString();
                }
                else
                {
                 //  cannot parse
                 //probably we are in IE
                 //try to get using different methods
                    if(repoobject.nextSibling   && repoobject.nextSibling.attributes && repoobject.nextSibling.attributes['repositoryId'])
                    {
                        id = repoobject.nextSibling.attributes['repositoryId'].toString();
                        name=repoobject.nextSibling.attributes['repositoryName'].toString();
                        type=repoobject.nextSibling.attributes['repositoryType'].toString();
                    }
                    else
                    {
                        //do this to go to catch section 
                        id = repoobject.attributes['repositoryId'].toString();
                    }
                }
            }
            const existid = that.idlist.indexOf(id); 
            const existname = that.namelist.indexOf(name); 
            const existtype =  that.typelist.indexOf(type); 

            if(existtype != -1)//everithing OK
            {
                if(existid > -1 && existname > -1) //both are bad
                {
                    stat = that.ecmResourceStrings.idandnamebad;
                    statusdescription = that.ecmResourceStrings.txtImportStatusIdAndNameBad;
                }
                else //only one
                {
                    if(existid > -1)
                    {
                        stat = that.ecmResourceStrings.idbad;
                        statusdescription = that.ecmResourceStrings.txtImportStatusIdBad;
                    }
                    if(existname > -1)
                    {
                        stat = that.ecmResourceStrings.namebad;
                        statusdescription = that.ecmResourceStrings.txtImportStatusNameBad;
                    }
                }
            }
            else //type does not exists we can not import
            {
                stat = that.ecmResourceStrings.typedoesnotexist;
                statusdescription = that.ecmResourceStrings.txtImportStatusTypeDoesNotExists;
            }

            return {status:stat, statusdescription:statusdescription}
        },

        saveInRepository()
        {
            this.$snotify.async(this.ecmResourceStrings.txtStartSaving, {timeout: 0});

            var that = this;
            that.errorearray = [];
            that.originalselectednum = 0;
            that.processednum=0;
            const len = that.repoList.length;
            var i = 0;

            for(i = 0; i<len; i++)
            {
                if(that.repoList[i])
                {
                    //importerror is added, for example the engine was not ready but we start it and want to try save again. Why not?
                    if((that.repoList[i].status == that.ecmResourceStrings.readytoimport || that.repoList[i].status == that.ecmResourceStrings.importerror) && that.repoList[i].checked == true)
                    {
                        that.originalselectednum++;
                    }
                }
            }

            if(that.originalselectednum == 0)
            {
                //message box nothing is selected   
                this.$snotify.clear();
                this.$snotify.info(this.ecmResourceStrings.txtNothingToImport); 
                return;
            }
            that.importstarted = true;
            for(i = 0; i<len; i++)
            {
                if(that.repoList[i])
                {
                    if((that.repoList[i].status == that.ecmResourceStrings.readytoimport  || that.repoList[i].status == that.ecmResourceStrings.importerror) && that.repoList[i].checked == true)
                    {
                        var sendObj = [];
                        
                        sendObj.type = that.repoList[i].repositoryType;
                        var descval = "";
                        if(that.repoList[i].description)
                        {
                            descval = JSON.stringify(that.repoList[i].description); 
                            descval = descval.replace(/"/ , ""); 
                            descval = descval.replace(/"$/,"");
                        }
                        sendObj.description = descval;
                        sendObj.name = that.repoList[i].repositoryName;
                        sendObj.id = that.repoList[i].repositoryId;
                        sendObj.realConfigurations =that.repoList[i].configData;
                        
                        const connString=that.createBodyPostString(sendObj);
                        that.startImport(connString, sendObj.id, sendObj.name, that.repoList[i]);
                    }
                }
            }
        },

        createBodyPostString(sendObj)
        {
            var configstring = "";

            if (_.isUndefined(sendObj))
                return configstring;

            var that = this;


            for (var cnt = 0; cnt < sendObj.realConfigurations.length; cnt++)
            {
                if(sendObj.realConfigurations[cnt])
                {
                    const configname = sendObj.realConfigurations[cnt].name;
                    const namesArray = configname.split(".");
                    const lennames = namesArray.length;
                    var bSavedStatus = false;
                    if(lennames > 2)
                    {
                        const paramName = namesArray[2]; 
                        if(paramName == 'status' || paramName == 'statusDate')
                        {
                            bSavedStatus = true;
                        }
                    }
                   
                    const configtype = sendObj.realConfigurations[cnt].type;
                    var configvalueoriginal = sendObj.realConfigurations[cnt].value;
                    var configdescr = "";
                    
                    if(sendObj.realConfigurations[cnt].description)
                    {
                        configdescr = JSON.stringify(sendObj.realConfigurations[cnt].description); 
                        //configdescr = configdescr.replace(/"/g, ""); 
                        configdescr = configdescr.replace(/"/ , ""); 
                        configdescr = configdescr.replace(/"$/,"");
                    }

                    if(configvalueoriginal == undefined)
                        configvalueoriginal="";
                    var configvalue = "";
                    if(bSavedStatus == false)
                    {
                        if(configtype == "string")
                        {
                            if(configvalueoriginal.length > 0)
                            {
                                configvalue = JSON.stringify(configvalueoriginal); 
                                //configvalue = configvalue.replace(/"/g, ""); 
                                configvalue = configvalue.replace(/"/ , ""); 
                                configvalue = configvalue.replace(/"$/,"");
                            }
                        }
                        else
                        {
                            configvalue = configvalueoriginal; 
                        }
                    }
                    var strTemp = '{"name": "' + configname +'", "value": "' + configvalue +'", "type": "' + configtype +'", "description": "' + configdescr +'"}';
                    
                    if(cnt == sendObj.realConfigurations.length -1)
                        configstring = configstring + strTemp;
                    else
                        configstring = configstring + strTemp + ',';
                }
            }

            const connString = '{"repositoryId": "' + sendObj.id + '", "repositoryName": "' + sendObj.name + '", "repositoryType": "' + sendObj.type + '", "description": "' + sendObj.description + '", "configData":[' + configstring + ']}';

            return connString;
        },

        startImport(connString, id, name, repo)
        {
            var that = this;
             axios.post('/mtm-gateway-api/v1/services/ecm/ECMRepositories', connString,  {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then(() => {
                    that.processednum++;
                    that.errorearray.push({"id" : id, "name" : name, "error": "SUCCEEDED"});
                    if(repo)
                    {
                        repo.importstatus = "SUCCEEDED";
                        repo.status=that.ecmResourceStrings.importsuccess;
                        repo.statusdescription='';
                        repo.checked = null;
                        that.idlist.push(id);  //for what ???
                        that.namelist.push(name);
                        if(repo.importstatuslog)
                        repo.importstatuslog="";
                    }

                    if(that.originalselectednum == that.processednum)
                    {
                        this.$snotify.clear();
                        this.$snotify.success(this.ecmResourceStrings.txtECMRepositoriesConfigsSaved);
                        that.importstarted = false;
                    }
                })
                .catch((err) => {
                    that.processednum++;
                    if(repo)
                    {
                        repo.importstatus = err.response.statusText;
                        repo.status=that.ecmResourceStrings.importerror;
                        repo.statusdescription=that.ecmResourceStrings.txtImportResult4;
                        if(err.response)
                        {
                            that.errorearray.push({"id" : id, "name" : name, "error": err.response.statusText + ': \n' + err.response.data});
                            repo.importstatuslog= err.response.data;
                        }
                        else if(err.message)
                        {
                            that.errorearray.push({"id" : id, "name" : name, "error": err.response.statusText + ': \n' + err.message});
                            repo.importstatuslog= err.message;
                        }
                        else{
                            that.errorearray.push({"id" : id, "name" : name, "error": err.response.statusText + ': \n' + that.ecmResourceStrings.errImportECMRepositories});
                            repo.importstatuslog= that.ecmResourceStrings.errImportECMRepositories1;
                        }

                        if(that.originalselectednum == that.processednum)
                        {   
                            that.importstarted = false;
                            var errortext='';
                            if(that.errorearray.length > 0)
                            {
                                var i = 0;
                                for(i=0;i<that.errorearray.length; i++)
                                {
                                    errortext += that.ecmResourceStrings.txtImportResult2;errortext +=that.errorearray[i].id;errortext += '\n';
                                    errortext += that.ecmResourceStrings.txtImportResult3;errortext +=that.errorearray[i].name;errortext += '\n';
                                    errortext += that.errorearray[i].error;errortext += '\n';
                                    errortext += '\n';
                                }
                            }
                            this.$snotify.clear();
                            this.$snotify.error(err.response.statusText, that.ecmResourceStrings.txtError, {
                                buttons: [
                                    {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', this.ecmResourceStrings.txtImportResult, that.ecmResourceStrings.errImportECMRepositories, true, errortext), bold: true },
                                ],
                            });
                        }
                    }
                    else{
                        this.$snotify.clear();
                    }
                }
            );
        },
    },

    mounted() {
         var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repositories',
            meta: { label: 'Repositories' }
        },{
            name: 'ecm-repositories-import',
            meta: { label: 'Import ECM Repositories Configurations' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
       
        Promise.all([
                that.ecmRepositories.fetch( {"Content-Type": "application/json; charset=UTF-8"}),
            ]).then(() => {
                const colOfEcmRepositories =  that.ecmRepositories.resources;
                if(colOfEcmRepositories)
                {
                    const lenx = colOfEcmRepositories.length;
                    for(var j=0; j<lenx; j++)
                    {
                        const onerepo = colOfEcmRepositories[j];
                        if(onerepo)
                        {
                            const id = onerepo.attributes['repositoryId'];
                            const name = onerepo.attributes['repositoryName'];
                            that.idlist.push(id.toString());
                            that.namelist.push(name.toString());
                        }
                    }
                }

                that.ecmRepositoryTypes.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                    const colRepositoryTypes =  that.ecmRepositoryTypes.resources;

                    if(colRepositoryTypes)
                    {
                        const len = colRepositoryTypes.length;

                        for(var i=0; i<len; i++)
                        {
                            const oneelement = colRepositoryTypes[i];

                            if(oneelement)
                            {
                                const rt = oneelement.attributes['repositoryType'];
                                    
                                that.typelist.push(rt.toString());  
                            }
                        }
                    }
                    that.loaded = true;
                })
                .catch((err) => {
                    console.log(err);
                    that.loaded = true;
                });

                that.loaded = true;

            })
            .catch((err) => {
                console.log(err);
                that.loaded = true;
            });

    },

}
</script>